import { LazyFallback } from "@msuite/ui/loading-screen";
import { Panels } from "@msuite/ui/panels";
import { lazy, Suspense } from "react";
import { useIncomingInvoice } from "@/hooks/use-incoming-invoice";
import type { IncomingInvoicePanelBaseProps } from "../../shared";
import { IncomingInvoiceDetails } from "./incoming-invoice-details";
import { IncomingInvoiceIssuer } from "./incoming-invoice-issuer";
import { IncomingInvoiceOffsets } from "./incoming-invoice-offsets";
import { IncomingInvoicePayment } from "./incoming-invoice-payment";
import { IncomingInvoiceReduction } from "./incoming-invoice-reduction";

const Notes = lazy(() => import("@/components/notes"));

export function IncomingInvoiceGeneral({ incomingInvoiceId }: IncomingInvoicePanelBaseProps) {
	/** Query */
	const { incomingInvoice } = useIncomingInvoice(incomingInvoiceId);

	/** Render */
	return (
		<Panels>
			<Panels.Panel
				flex={1}
				className="bottom-space"
			>
				<IncomingInvoiceDetails incomingInvoice={incomingInvoice} />
				<IncomingInvoiceReduction incomingInvoice={incomingInvoice} />
				<IncomingInvoiceIssuer incomingInvoice={incomingInvoice} />
				<IncomingInvoiceOffsets incomingInvoice={incomingInvoice} />
				<IncomingInvoicePayment incomingInvoice={incomingInvoice} />
			</Panels.Panel>
			<Panels.Panel flex={2}>
				<Suspense fallback={<LazyFallback variant="inline" />}>
					<Notes
						notesTable="incomingInvoiceNotes"
						identifier={incomingInvoiceId}
						parent={incomingInvoice}
					/>
				</Suspense>
			</Panels.Panel>
		</Panels>
	);
}
